import { createContext } from 'react';

import { MessageContextAction } from './message-composer-reducer';

import { LanguageCode } from '../../../util/languages';
import { MESSAGE_TYPE, MessageType } from '../../../util/message-types';

export type LanguageState = {
  message: string;
  urlFileMappings?: Array<UrlFileMapping>;
  messageError?: string | null;
  messageWarning?: string | null;
  subjectError?: string | null;
  // translation specific state
  isTranslating?: boolean;
  streamingHackText?: string;
};

export type MessageComposerContextState = {
  messageType: MessageType;
  languageToState: Record<LanguageCode, LanguageState>;
  /**
   * True if any object in languageToState has a messageError
   */
  hasErrors: boolean;
  /**
   * Overwritten for MessageInput context
   * Not used in MLMC
   */
  languageCode: LanguageCode;
  isLoading: boolean;
  /**
   * Number of files that have been uploaded across all languages. Counts files
   * that were uploaded then removed from the message.
   */
  fileCount: number;
  /**
   * Used by consumers that maintain their own message state (such as
   * RichTextEditorInContext) to determine whether or not to force a state
   * update
   */
  forceUpdate: boolean;
  /**
   * turn off the subject field for emails and ignore subject errors
   */
  disableSubject?: boolean;
};

export const MessageComposerContext = createContext<MessageComposerContextState>({
  languageToState: { en: { message: '' } },
  languageCode: 'en',
  messageType: MESSAGE_TYPE.TEXT,
  isLoading: false,
  hasErrors: false,
  fileCount: 0,
  forceUpdate: false,
});

export const MessageComposerDispatchContext = createContext<React.Dispatch<MessageContextAction>>(
  () => ({} as MessageContextAction),
);
